import clsx from "clsx";

export const TEXT_VARIANTS_VARIABLES = {
  default: "default",
  title: "title",
  link: "link",
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  fourth: "fourth",
  error: "error",
} as const;

export const TEXT_VARIANTS = {
  [TEXT_VARIANTS_VARIABLES.default]: clsx("text-text-primary"),
  [TEXT_VARIANTS_VARIABLES.error]: clsx("text-text-error"),
  [TEXT_VARIANTS_VARIABLES.link]: clsx("text-blue-600 underline"),
  [TEXT_VARIANTS_VARIABLES.primary]: clsx("text-black"),
  [TEXT_VARIANTS_VARIABLES.secondary]: clsx("text-text-secondary"),
  [TEXT_VARIANTS_VARIABLES.tertiary]: clsx("text-text-tertiary"),
  [TEXT_VARIANTS_VARIABLES.fourth]: clsx("text-text-fourth"),
  [TEXT_VARIANTS_VARIABLES.title]: clsx("text-text-primary font-bold"),
};
